import Add from "../table/Add";
import { useState } from "react";
import { useNavigate} from "react-router-dom";
import ApiService from "../../services/apiService";
import { method } from "lodash";
import { toast } from "react-toastify";
import { Label } from "reactstrap";
import validation from "ajv/dist/vocabularies/validation";


const AddPumpingStation =  () =>{
       const navigate = useNavigate();

       const onSubmit = async(data:any) =>{
           
           try{
               const pumpingstationData ={
                  Name:data.Name,
                  Type:data.Type,
                  No_Of_Pumps:data.No_Of_Pumps,
                  IncludeInDashboard: data.IncludeInDashboard === 'true' ? true : false
               }

               const response = await ApiService.axiosApi(`/pumpingstation`,{
                  method:'POST',
                  data: pumpingstationData
               });

               if(response.success){
                  toast.success("Pumping Station Added Successfully")
                  navigate(-1)
               }else{
                 toast.error( response.data.message || "Failed to Add Pumping Station")
               }
           }catch(error:any){
             toast.error(error.message || 'Failed to add Pumping Station')
           }
          
       }

       return (

    
         <Add
            title={'Add Pumping Station'}
            parentTitle ={'Pumping Station'}
            onSubmit = {onSubmit}

            fields ={[
                 {
                    name:'Name',
                    label: 'Name',
                    type :'text',
                    validation : { required : 'Name is Required'}
                 },
                 {
                     name:'Type',
                     label:'Type',
                     type:'text',
                     validation:{required:'Type is required'}

                 },
                 {
                     name:'No_Of_Pumps',
                     label:'Number Of Pumps',
                     type:'text',
                     validation: {required:'Number of Pumps is Required'}
                 },
                 {
                    name:'IncludeInDashboard',
                    label:'Include In Dashboard',
                    type:'text',
                    validation:{required:'Include In Dashboard is Required'}
                 }
                
            ]}
          />
    
    )
}

export default AddPumpingStation